// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PHM2z","right":"styles_right__32ag7"};